import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private resources: string[],
  ) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    const requests: Observable<TranslationObject>[] = this.resources.map((path) =>
      this.http.get<TranslationObject>(`${path}/${lang}.json`).pipe(
        catchError((error) => {
          console.warn(`[i18n] Could not load translation file: ${path}/${lang}.json`, error);
          return of({} as TranslationObject);
        }),
      ),
    );

    return forkJoin(requests).pipe(
      map((responses: TranslationObject[]) =>
        responses.reduce<TranslationObject>(
          (acc, curr) => ({
            ...acc,
            ...curr,
          }),
          {} as TranslationObject,
        ),
      ),
    );
  }
}
